import { block, unblock } from './block';

export default class Validation {
	constructor(elements, state) {
		this.state = state;
		this.elements = elements;
		this.valid = false;

		this.elements.form.addEventListener('submit', this.validateForm.bind(this));
	}

	async validateForm(e) {

		if (this.state.type === 'voucher') { // validation for voucher is not required
			return;
		}

		const errors = [];

		if (!this.elements.date.value || this.elements.date.value == '') {
			errors.push('Invalid Date');
		}

		if (!this.elements.time.value || this.elements.time.value == '') {
			errors.push('Invalid Time');
		}

		if (this.state.type === 'redeem' && (!this.elements.coupon.value || this.elements.coupon.value == '')) {
			errors.push('Invalid Voucher');
		}

		if (this.state.type === 'redeem' && !this.valid && !errors.length) {
			e.preventDefault();
			block(this.elements.form);

			jQuery.ajax({
				url: hpy_single_event.ajaxurl,
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'hpy_events_redeem_voucher',
					coupon: this.elements.coupon.value,
				},
				success: response => {
					if (response.success) {
						this.valid = true;
						jQuery(this.elements.form).find('button[type="submit"]').trigger('click');
					} else {
						errors.push(response.data.error);
					}
				},
				complete: () => {
					if (errors.length) {
						this.error(errors.join('\r\n'));
						unblock(this.elements.form);
					}
				},
			});
		} else if (errors.length) {
			e.preventDefault();
			this.error(errors.join('\r\n'));
		}

	}

	error(message) {
		alert(message ? message : 'Unspecified Error');
	}

	applyCoupon() {
		return new Promise((resolve, reject) => {
			if (!this.elements.coupon.value || this.elements.coupon.value === '') {
				reject('Please Enter a Voucher Code');
				return;
			}




		});
	}
}